/** Why an issue that could be checked is not attributed traffic lost. */
export const NOT_ATTRIBUTED = { noDrop: "no drop", dropBefore: "drop before the issue" };
